import axios from 'axios';

/**
 * 获取商品列表
 *
 * @param {*} params
 * @param {string} key      授权Token
 * @param {string} category
 * @param {string} order    筛选
 *        item_ref    A-z排列
 *        id          最新创建
 *        sales       销量
 *        sales_price 销售额
 *        stock       在仓库存
 *        presale_quantity 预售
 *        reserve_quantity 预定
 *        onway_quantity   在途
 *        owe_quantity     欠货
 * @param {number} isasc    升降序 0-降序 1-升序
 * @param {number} show_sku 是否展示被删除 SKU  0-降序 1-升序
 * @param {string} type     自定义日期筛选关键字 today this_week custom 等
 * @param {string} sday	    开始时间，格式：YYYY-MM-DD
 * @param {string} eday	    结束时间，格式：YYYY-MM-DD
 * @param {number} days     最近多少天  0-历史到现在  -1-自定义，根据 sday eday 表示起止时间 其他-最近数最近多少天
 * @param {number} disable  商品是否作废 0-不作废 1-作废
 * @param {number} page	    页码
 * @param {number} page_num 条数/页
 */
export function requestGoodList(params) {
  return axios.post('/goods/get_by_order', params);
}
/**
 * 搜索商品
 *
 * @param {*} params
 * @param {string} key     授权 Token
 * @param {string} keyword 关键词
 * @param {number} disable
 * @param {string} order
 */
export function requestGoodSearch(params) {
  return axios.post('/goods/search', params);
}
/**
 * 删除商品(暂无用，统一使用批量修改)
 *
 * @param {*} params
 * @param {string} key  授权 Token
 * @param {string} id   商品 ID
 */
export function requestGoodDelete(params) {
  return axios.post('/goods/del', params);
}
/**
 * 批量删除商品(暂无用，统一使用批量修改)
 *
 * @param {*} params
 * @param {string} key      授权 Token
 * @param {array} id_list   商品 ID 数组
 */
export function requestGoodDeleteBatch(params) {
  return axios.post('/goods/batch_del', params);
}
/**
 * 启用/停用商品(暂无用，统一使用批量修改)
 *
 * @param {*} params
 * @param {string} key      授权 Token
 * @param {string} id       商品 ID
 * @param {number} disable  商品是否停用 0-启用 1-停用
 */
export function requestGoodDisable(params) {
  return axios.post('/goods/disable', params);
}
/**
 * 批量修改商品属性
 *
 * @param {*} params
 * @param {string} key        授权 Token
 * @param {number} quantity   修改的商品数量
 * @param {object} attribute  修改的商品属性
 * @param {object} fllter     筛选条件
 */
export function requestGoodAttrBatch(params) {
  return axios.post('/goods/batch_set_attribute', params);
}

/**
 * 导入商品
 *
 * @param {*} params
 * @param {string} key      授权 Token
 * @param {string} import   商品详情 - JSON
 */
export function requestGoodImport(params) {
  return axios.post('/goods/import', params);
}
/**
 * 获取商品分类
 *
 * @param {*} params
 * @param {string} key      授权 Token
 */
export function requestGoodCategory(params) {
  return axios.post('/goods/get_category', params);
}
/**
 * 横排商品导出(已废弃)
 *
 * @param {*} params
 * @param {string} key      授权 Token  responseType: 'blob'
 */
export function requestGoodExport(params) {
  return axios.get('/report/export_goods_info', { responseType: 'blob', params: params });
}
/**
 * 竖排商品导出
 *
 * @param {*} params
 * @param {string} key      授权 Token  responseType: 'blob'
 */
export function reqVerticalGoodExport(params) {
  return axios.get('/report/export_goods_info_new', { responseType: 'blob', params: params });
}

/**
 * 新导入商品
 *
 * @param {*} params
 * @param {string} key      授权 Token
 * @param {string} import   商品详情 - JSON
 */
export function reqGoodImport(params) {
  return axios.post('/goods/import_v1', params, { needResponse: 1 });
}

/**
 * 获取店铺列表
 *
 * @param {*} params
 * @param {string} key      授权 Token
 */
export function requestShop(params) {
  return axios.post('/user/shop_list', params);
}

/**
 * 获取商品详情
 *
 * @param {*} params
 * @param {string} key      授权 Token
 */
export function reqGoodDetail(params) {
  return axios.post('/goods/get', params)
}
